export const environment = {
  production: true,
  dominio: "https://servicios.banca.api.multientregapanama.com/api/",
  dominio2: "https://admin.multientregapanama.com/api/",
  cryptoSecretKey: 'Y90XVQSAZBXI9J6O5HST2U6WK8R9KH6O'
};
